module.exports = __webpack_public_path__ + "img/digital-art_teaser.a754acb9.jpg";